module.exports = __webpack_public_path__ + "img/shape-24.6d30a085.png";